import About from "./Pages/Home/About";
import Footer from "./Pages/Home/Footer";
import Header from "./Pages/Home/Header";
import Milestone from "./Pages/Home/Milestone";
import Recipies from "./Pages/Home/Recipies";

function App() {
  return (
    <div>
     <Header></Header>
     <About></About>
     <Recipies></Recipies>
     <Milestone></Milestone>
     <Footer></Footer>
    </div>
  );
}

export default App;
